export default __webpack_public_path__ + "static/media/p29.0a44e03c.jpg";